module.exports = __webpack_public_path__ + "static/media/service_address_2-2.e54678c4.png";